export default __webpack_public_path__ + "static/media/87.fa65f20e.jpeg";